import script from "./SavedMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./SavedMobile.vue?vue&type=script&setup=true&lang=js"

import "./SavedMobile.vue?vue&type=style&index=0&id=5adaa423&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5adaa423"]])

export default __exports__